const AdvEditSvg = () => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none">
          <path fill="#546EDB" fillRule="evenodd" d="M9.844 1.748a.219.219 0 0 0-.312-.198L4.674 3.835c-.383.18-.627.565-.627.987v1.95h5.797V1.747Zm1.312 5.15v-5.15c0-1.121-1.168-1.86-2.184-1.383L4.115 2.65a2.401 2.401 0 0 0-1.38 2.172v2.086c-.58.252-.985.83-.985 1.5v1.129c-.385.18-.69.515-.822.939L.03 13.343a.656.656 0 0 0 1.253.39l.898-2.867a.236.236 0 0 1 .225-.165h9.188c.103 0 .194.067.225.165l.898 2.868a.656.656 0 0 0 1.253-.39l-.898-2.868a1.546 1.546 0 0 0-.822-.94V8.518c0-.733-.453-1.36-1.094-1.62Zm-.219 2.493v-.873a.437.437 0 0 0-.437-.437H3.39a.328.328 0 0 0-.327.328v.982h7.874Z" clipRule="evenodd"/>
      </svg>
  )
}

export default AdvEditSvg;